import { useEffect } from 'react';
import Icon from "./Icon";

const SuccessMessage = ({ message, onClose, autoClose = false, duration = 3000, type = 'success' }) => {
    // Auto close functionality only for success messages - DISABLED for user interaction requirement
    useEffect(() => {
        // Auto close is now disabled to ensure user must click Continue button
        // Keeping the code commented to show original intent but functionality removed
        /*
        if (message && autoClose && type === 'success') {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
        */
    }, [message, autoClose, duration, onClose, type]);

    // Prevent body scroll when modal is open
    useEffect(() => {
        if (message) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }

        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [message]);

    if (!message) return null;

    // Different configurations based on type
    const config = {
        success: {
            borderColor: '#198754',
            iconName: 'success-icon',
            title: 'Success!',
            btnClass: 'success-continue-btn'
        },
        error: {
            borderColor: '#f59e0b',
            iconName: 'warning-icon',
            title: 'Warning!',
            btnClass: 'error-continue-btn'
        }
    };

    const currentConfig = config[type];

    return (
        <>
            {/* Overlay with #5E6472CC color */}
            <div className="modal-overlay" />
            
            {/* Modal Content */}
            <div 
                className="message-modal"
                style={{ borderTopColor: currentConfig.borderColor }}
            >
                <div className="message-content-wrapper">
                    <Icon
                        name={currentConfig.iconName}
                        size={32}
                    />
                    <div className="message-title">
                        {currentConfig.title}
                    </div>
                </div>

                <div className="message-description">
                    {message}
                </div>

                <div className="message-footer">
                    <button
                        onClick={onClose}
                        className={currentConfig.btnClass}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </>
    );
};

export default SuccessMessage;